const countryData = Object.freeze([
    { key: 'united_states', phoneCode: '+1' },
    { key: 'canada', phoneCode: '+1' },
    { key: 'egypt', phoneCode: '+20' },
    { key: 'south_sudan', phoneCode: '+211' },
    { key: 'morocco', phoneCode: '+212' },
    { key: 'algeria', phoneCode: '+213' },
    { key: 'tunisia', phoneCode: '+216' },
    { key: 'libya', phoneCode: '+218' },
    { key: 'gambia', phoneCode: '+220' },
    { key: 'senegal', phoneCode: '+221' },
    { key: 'mauritania', phoneCode: '+222' },
    { key: 'mali', phoneCode: '+223' },
    { key: 'guinea', phoneCode: '+224' },
    { key: 'ivory_coast', phoneCode: '+225' },
    { key: 'burkina_faso', phoneCode: '+226' },
    { key: 'niger', phoneCode: '+227' },
    { key: 'togo', phoneCode: '+228' },
    { key: 'benin', phoneCode: '+229' },
    { key: 'mauritius', phoneCode: '+230' },
    { key: 'liberia', phoneCode: '+231' },
    { key: 'sierra_leone', phoneCode: '+232' },
    { key: 'ghana', phoneCode: '+233' },
    { key: 'nigeria', phoneCode: '+234' },
    { key: 'chad', phoneCode: '+235' },
    { key: 'central_african_republic', phoneCode: '+236' },
    { key: 'cameroon', phoneCode: '+237' },
    { key: 'cape_verde', phoneCode: '+238' },
    { key: 'sao_tome_and_principe', phoneCode: '+239' }, // São Tomé and Príncipe
    { key: 'equatorial_guinea', phoneCode: '+240' },
    { key: 'gabon', phoneCode: '+241' },
    { key: 'republic_of_the_congo', phoneCode: '+242' },
    { key: 'democratic_republic_of_the_congo', phoneCode: '+243' },
    { key: 'angola', phoneCode: '+244' },
    { key: 'guinea-bissau', phoneCode: '+245' },
    { key: 'british_indian_ocean_territory', phoneCode: '+246' },
    { key: 'ascension_island', phoneCode: '+247' },
    { key: 'seychelles', phoneCode: '+248' },
    { key: 'sudan', phoneCode: '+249' },
    { key: 'rwanda', phoneCode: '+250' },
    { key: 'ethiopia', phoneCode: '+251' },
    { key: 'somalia', phoneCode: '+252' },
    { key: 'djibouti', phoneCode: '+253' },
    { key: 'kenya', phoneCode: '+254' },
    { key: 'tanzania', phoneCode: '+255' },
    { key: 'uganda', phoneCode: '+256' },
    { key: 'burundi', phoneCode: '+257' },
    { key: 'mozambique', phoneCode: '+258' },
    { key: 'zambia', phoneCode: '+260' },
    { key: 'madagascar', phoneCode: '+261' },
    { key: 'reunion', phoneCode: '+262' }, // Réunion
    { key: 'zimbabwe', phoneCode: '+263' },
    { key: 'namibia', phoneCode: '+264' },
    { key: 'malawi', phoneCode: '+265' },
    { key: 'lesotho', phoneCode: '+266' },
    { key: 'botswana', phoneCode: '+267' },
    { key: 'eswatini', phoneCode: '+268' },
    { key: 'comoros', phoneCode: '+269' },
    { key: 'south_africa', phoneCode: '+27' },
    { key: 'saint_helena', phoneCode: '+290' },
    { key: 'eritrea', phoneCode: '+291' },
    { key: 'aruba', phoneCode: '+297' },
    { key: 'faroe_islands', phoneCode: '+298' },
    { key: 'greenland', phoneCode: '+299' },
    { key: 'greece', phoneCode: '+30' },
    { key: 'netherlands', phoneCode: '+31' },
    { key: 'belgium', phoneCode: '+32' },
    { key: 'france', phoneCode: '+33' },
    { key: 'spain', phoneCode: '+34' },
    { key: 'gibraltar', phoneCode: '+350' },
    { key: 'portugal', phoneCode: '+351' },
    { key: 'luxembourg', phoneCode: '+352' },
    { key: 'ireland', phoneCode: '+353' },
    { key: 'iceland', phoneCode: '+354' },
    { key: 'albania', phoneCode: '+355' },
    { key: 'malta', phoneCode: '+356' },
    { key: 'cyprus', phoneCode: '+357' },
    { key: 'finland', phoneCode: '+358' },
    { key: 'bulgaria', phoneCode: '+359' },
    { key: 'hungary', phoneCode: '+36' },
    { key: 'lithuania', phoneCode: '+370' },
    { key: 'latvia', phoneCode: '+371' },
    { key: 'estonia', phoneCode: '+372' },
    { key: 'moldova', phoneCode: '+373' },
    { key: 'armenia', phoneCode: '+374' },
    { key: 'belarus', phoneCode: '+375' },
    { key: 'andorra', phoneCode: '+376' },
    { key: 'monaco', phoneCode: '+377' },
    { key: 'san_marino', phoneCode: '+378' },
    { key: 'vatican_city', phoneCode: '+379' },
    { key: 'ukraine', phoneCode: '+380' },
    { key: 'serbia', phoneCode: '+381' },
    { key: 'montenegro', phoneCode: '+382' },
    { key: 'kosovo', phoneCode: '+383' },
    { key: 'croatia', phoneCode: '+385' },
    { key: 'slovenia', phoneCode: '+386' },
    { key: 'bosnia_and_herzegovina', phoneCode: '+387' },
    { key: 'north_macedonia', phoneCode: '+389' },
    { key: 'italy', phoneCode: '+39' },
    { key: 'romania', phoneCode: '+40' },
    { key: 'switzerland', phoneCode: '+41' },
    { key: 'czech_republic', phoneCode: '+420' },
    { key: 'slovakia', phoneCode: '+421' },
    { key: 'liechtenstein', phoneCode: '+423' },
    { key: 'austria', phoneCode: '+43' },
    { key: 'united_kingdom', phoneCode: '+44' },
    { key: 'denmark', phoneCode: '+45' },
    { key: 'sweden', phoneCode: '+46' },
    { key: 'norway', phoneCode: '+47' },
    { key: 'poland', phoneCode: '+48' },
    { key: 'germany', phoneCode: '+49' },
    { key: 'falkland_islands', phoneCode: '+500' },
    { key: 'belize', phoneCode: '+501' },
    { key: 'guatemala', phoneCode: '+502' },
    { key: 'el_salvador', phoneCode: '+503' },
    { key: 'honduras', phoneCode: '+504' },
    { key: 'nicaragua', phoneCode: '+505' },
    { key: 'costa_rica', phoneCode: '+506' },
    { key: 'panama', phoneCode: '+507' },
    { key: 'saint-pierre_and_miquelon', phoneCode: '+508' },
    { key: 'haiti', phoneCode: '+509' },
    { key: 'peru', phoneCode: '+51' },
    { key: 'mexico', phoneCode: '+52' },
    { key: 'cuba', phoneCode: '+53' },
    { key: 'argentina', phoneCode: '+54' },
    { key: 'brazil', phoneCode: '+55' },
    { key: 'chile', phoneCode: '+56' },
    { key: 'colombia', phoneCode: '+57' },
    { key: 'venezuela', phoneCode: '+58' },
    { key: 'guadeloupe', phoneCode: '+590' },
    { key: 'bolivia', phoneCode: '+591' },
    { key: 'guyana', phoneCode: '+592' },
    { key: 'ecuador', phoneCode: '+593' },
    { key: 'french_guiana', phoneCode: '+594' },
    { key: 'paraguay', phoneCode: '+595' },
    { key: 'martinique', phoneCode: '+596' },
    { key: 'suriname', phoneCode: '+597' },
    { key: 'uruguay', phoneCode: '+598' },
    { key: 'netherlands_antilles', phoneCode: '+599' },
    { key: 'malaysia', phoneCode: '+60' },
    { key: 'australia', phoneCode: '+61' },
    { key: 'indonesia', phoneCode: '+62' },
    { key: 'philippines', phoneCode: '+63' },
    { key: 'new_zealand', phoneCode: '+64' },
    { key: 'singapore', phoneCode: '+65' },
    { key: 'thailand', phoneCode: '+66' },
    { key: 'east_timor', phoneCode: '+670' },
    { key: 'australian_external_territories', phoneCode: '+672' },
    { key: 'brunei', phoneCode: '+673' },
    { key: 'nauru', phoneCode: '+674' },
    { key: 'papua_new_guinea', phoneCode: '+675' },
    { key: 'tonga', phoneCode: '+676' },
    { key: 'solomon_islands', phoneCode: '+677' },
    { key: 'vanuatu', phoneCode: '+678' },
    { key: 'fiji', phoneCode: '+679' },
    { key: 'palau', phoneCode: '+680' },
    { key: 'wallis_and_futuna', phoneCode: '+681' },
    { key: 'cook_islands', phoneCode: '+682' },
    { key: 'niue', phoneCode: '+683' },
    { key: 'samoa', phoneCode: '+685' },
    { key: 'kiribati', phoneCode: '+686' },
    { key: 'new_caledonia', phoneCode: '+687' },
    { key: 'tuvalu', phoneCode: '+688' },
    { key: 'french_polynesia', phoneCode: '+689' },
    { key: 'tokelau', phoneCode: '+690' },
    { key: 'federated_states_of_micronesia', phoneCode: '+691' },
    { key: 'marshall_islands', phoneCode: '+692' },
    { key: 'russia', phoneCode: '+7' },
    { key: 'japan', phoneCode: '+81' },
    { key: 'south_korea', phoneCode: '+82' },
    { key: 'vietnam', phoneCode: '+84' },
    { key: 'north_korea', phoneCode: '+850' },
    { key: 'hong_kong', phoneCode: '+852' },
    { key: 'macau', phoneCode: '+853' },
    { key: 'cambodia', phoneCode: '+855' },
    { key: 'laos', phoneCode: '+856' },
    { key: 'china', phoneCode: '+86' },
    { key: 'bangladesh', phoneCode: '+880' },
    { key: 'taiwan', phoneCode: '+886' },
    { key: 'turkey', phoneCode: '+90' },
    { key: 'india', phoneCode: '+91' },
    { key: 'pakistan', phoneCode: '+92' },
    { key: 'afghanistan', phoneCode: '+93' },
    { key: 'sri_lanka', phoneCode: '+94' },
    { key: 'myanmar', phoneCode: '+95' },
    { key: 'maldives', phoneCode: '+960' },
    { key: 'lebanon', phoneCode: '+961' },
    { key: 'jordan', phoneCode: '+962' },
    { key: 'syria', phoneCode: '+963' },
    { key: 'iraq', phoneCode: '+964' },
    { key: 'kuwait', phoneCode: '+965' },
    { key: 'saudi_arabia', phoneCode: '+966' },
    { key: 'yemen', phoneCode: '+967' },
    { key: 'oman', phoneCode: '+968' },
    { key: 'palestine', phoneCode: '+970' },
    { key: 'united_arab_emirates', phoneCode: '+971' },
    { key: 'israel', phoneCode: '+972' },
    { key: 'bahrain', phoneCode: '+973' },
    { key: 'qatar', phoneCode: '+974' },
    { key: 'bhutan', phoneCode: '+975' },
    { key: 'mongolia', phoneCode: '+976' },
    { key: 'nepal', phoneCode: '+977' },
    { key: 'iran', phoneCode: '+98' },
    { key: 'tajikistan', phoneCode: '+992' },
    { key: 'turkmenistan', phoneCode: '+993' },
    { key: 'azerbaijan', phoneCode: '+994' },
    { key: 'georgia', phoneCode: '+995' },
    { key: 'kyrgyzstan', phoneCode: '+996' },
    { key: 'kazakhstan', phoneCode: '+997' },
    { key: 'uzbekistan', phoneCode: '+998' },
]);

const SEPARATOR = '@';

const getCountryByPhoneCode = (phoneCode) =>
    countryData.find((country) => country.phoneCode === phoneCode);

const getAllCountries = () => countryData;

const convertPhoneCodeToKey = (phoneCode) => {
    const country = getCountryByPhoneCode(phoneCode);
    if (!country) {
        return undefined;
    }
    return `${country.phoneCode}${SEPARATOR}${country.key}`;
};

const formatPhoneCountryCode = (phoneNumber) => (phoneNumber ? `+${phoneNumber}` : '');

export { convertPhoneCodeToKey, formatPhoneCountryCode, getAllCountries, getCountryByPhoneCode };
